import React, { useState } from 'react';
import { ChevronDown, ChevronRight, Instagram, Music, Settings, Users, HelpCircle, Menu, InstagramIcon } from 'lucide-react';

const SocialIntegrationsDashboard = () => {
    const [isInstagramEnabled, setIsInstagramEnabled] = useState(true);
    const [isSpotifyEnabled, setIsSpotifyEnabled] = useState(true);
    const [activeIntegrationTab, setActiveIntegrationTab] = useState('Instagram');
    const [formData, setFormData] = useState({
        clientId: 'CLIENT_ID',
        secretKey: '•••••••••••••••••••••',
        redirectUrl: 'https://yourapp.com/auth/system/callback',
        apiVersion: 'v12.0(Latest)'
    });

    const handleInputChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleAddInstagram = () => {
        console.log('Adding Instagram integration with data:', formData);
        // Handle Instagram integration logic here
    };

    const handleAddSpotify = () => {
        console.log('Adding Spotify integration with data:', formData);
        // Handle Instagram integration logic here
    };

    return (
        <div className="flex min-h-screen">
            {/* Main Content */}
            <div className="flex-1 flex flex-col">
                {/* Breadcrumb */}
                <div className="bg-white border-b border-gray-200 px-4 py-4">
                    <div className="flex items-center space-x-2 text-sm text-gray-500">
                        <span>Dashboard</span>
                        <ChevronRight className="w-4 h-4" />
                        <span>Profile Metadata</span>
                        <ChevronRight className="w-4 h-4" />
                        <span className="text-gray-900">Social Integrations</span>
                    </div>
                </div>

                {/* Page Content */}
                <div className="flex-1 py-4 px-1">
                    <div className="max-w-4xl">
                        <h1 className="text-2xl font-bold text-gray-900 mb-2">Social Integrations</h1>
                        <p className="text-gray-600 mb-8">All social integrations on user profile are shown here</p>
                        <div className="grid grid-cols-1 lg:grid-cols-3 gap-3">
                            {/* Left Column - Social Platforms */}
                            <div className="space-y-3">
                                {/* Instagram */}
                                <div onClick={() => setActiveIntegrationTab("Instagram")} className={`cursor-pointer flex items-center space-x-3 p-4 ${activeIntegrationTab == "Instagram" ? 'bg-gray-900' : 'bg-white'} rounded-lg border border-gray-200`}>
                                    <InstagramIcon className="w-6 h-6 text-pink-500" />
                                    <span className={`font-medium ${activeIntegrationTab == "Instagram" ? 'text-white' : 'text-gray-900'}`}>Instagram</span>
                                </div>
                                {/* Spotify */}
                                <div onClick={() => setActiveIntegrationTab("Spotify")} className={`cursor-pointer flex items-center space-x-3 p-4 ${activeIntegrationTab == "Spotify" ? 'bg-gray-900' : 'bg-white'} rounded-lg border border-gray-200`}>
                                    <Music className="w-6 h-6 text-green-500" />
                                    <span className={`font-medium ${activeIntegrationTab == "Spotify" ? 'text-white' : 'text-gray-900'}`}>Spotify</span>
                                </div>
                            </div>
                            {/* Right Column - Configuration */}
                            {activeIntegrationTab == "Instagram" ?
                                <div className="lg:col-span-2">
                                    <div className="bg-white rounded-lg border border-gray-200 p-6">
                                        <div className="flex items-center justify-between">
                                            <h2 className="text-xl font-semibold text-gray-900">Instagram App Configuration</h2>
                                            <div className="flex items-center space-x-2">
                                                <button
                                                    onClick={() => setIsInstagramEnabled(!isInstagramEnabled)}
                                                    className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${isInstagramEnabled ? 'bg-gray-900' : 'bg-gray-300'}`}>
                                                    <span
                                                        className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${isInstagramEnabled ? 'translate-x-6' : 'translate-x-1'}`}
                                                    />
                                                </button>
                                            </div>
                                        </div>
                                        <span className="text-sm text-gray-600">Enable users to add Instagram on their profile</span>
                                        <div className="space-y-6 mt-6">
                                            {/* Client ID */}
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                                    Client ID
                                                </label>
                                                <input
                                                    type="text"
                                                    value={formData.clientId}
                                                    onChange={(e) => handleInputChange('clientId', e.target.value)}
                                                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-gray-50"
                                                    placeholder="YOUR_INSTAGRAM_CLIENT_ID"
                                                />
                                            </div>
                                            {/* Secret Key */}
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                                    Secret Key
                                                </label>
                                                <input
                                                    type="password"
                                                    value={formData.secretKey}
                                                    onChange={(e) => handleInputChange('secretKey', e.target.value)}
                                                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-gray-50"
                                                    placeholder="•••••••••••••••••••••"
                                                />
                                            </div>

                                            {/* Redirect URL */}
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                                    Redirect URL
                                                </label>
                                                <input
                                                    type="url"
                                                    value={formData.redirectUrl}
                                                    onChange={(e) => handleInputChange('redirectUrl', e.target.value)}
                                                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-gray-50"
                                                    placeholder="https://yourapp.com/auth/instagram/callback"
                                                />
                                            </div>

                                            {/* API Version */}
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                                    API Version
                                                </label>
                                                <div className="relative">
                                                    <select
                                                        value={formData.apiVersion}
                                                        onChange={(e) => handleInputChange('apiVersion', e.target.value)}
                                                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-gray-50 appearance-none">
                                                        <option value="v12.0(Latest)">v12.0(Latest)</option>
                                                        <option value="v11.0">v11.0</option>
                                                        <option value="v10.0">v10.0</option>
                                                    </select>
                                                    <ChevronDown className="absolute right-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" />
                                                </div>
                                            </div>
                                            {/* Add Button */}
                                            <button
                                                onClick={handleAddInstagram}
                                                className="px-6 py-2 bg-gray-900 text-white rounded-md hover:bg-gray-800 transition-colors font-medium">
                                                Add
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className="lg:col-span-2">
                                    <div className="bg-white rounded-lg border border-gray-200 p-6">
                                        <div className="flex items-center justify-between">
                                            <h2 className="text-xl font-semibold text-gray-900">Spotify App Configuration</h2>
                                            <div className="flex items-center space-x-2">
                                                <button
                                                    onClick={() => setIsSpotifyEnabled(!isSpotifyEnabled)}
                                                    className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${isSpotifyEnabled ? 'bg-gray-900' : 'bg-gray-300'}`}>
                                                    <span
                                                        className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${isSpotifyEnabled ? 'translate-x-6' : 'translate-x-1'}`}
                                                    />
                                                </button>
                                            </div>
                                        </div>
                                        <span className="text-sm text-gray-600">Enable users to add Spotify on their profile</span>
                                        <div className="space-y-6 mt-6">
                                            {/* Client ID */}
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                                    Client ID
                                                </label>
                                                <input
                                                    type="text"
                                                    value={formData.clientId}
                                                    onChange={(e) => handleInputChange('clientId', e.target.value)}
                                                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-gray-50"
                                                    placeholder="YOUR_INSTAGRAM_CLIENT_ID"
                                                />
                                            </div>
                                            {/* Secret Key */}
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                                    Secret Key
                                                </label>
                                                <input
                                                    type="password"
                                                    value={formData.secretKey}
                                                    onChange={(e) => handleInputChange('secretKey', e.target.value)}
                                                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-gray-50"
                                                    placeholder="•••••••••••••••••••••"
                                                />
                                            </div>

                                            {/* Redirect URL */}
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                                    Redirect URL
                                                </label>
                                                <input
                                                    type="url"
                                                    value={formData.redirectUrl}
                                                    onChange={(e) => handleInputChange('redirectUrl', e.target.value)}
                                                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-gray-50"
                                                    placeholder="https://yourapp.com/auth/instagram/callback"
                                                />
                                            </div>

                                            {/* API Version */}
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                                    API Version
                                                </label>
                                                <div className="relative">
                                                    <select
                                                        value={formData.apiVersion}
                                                        onChange={(e) => handleInputChange('apiVersion', e.target.value)}
                                                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-gray-50 appearance-none">
                                                        <option value="v12.0(Latest)">v12.0(Latest)</option>
                                                        <option value="v11.0">v11.0</option>
                                                        <option value="v10.0">v10.0</option>
                                                    </select>
                                                    <ChevronDown className="absolute right-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" />
                                                </div>
                                            </div>
                                            {/* Add Button */}
                                            <button
                                                onClick={handleAddSpotify}
                                                className="px-6 py-2 bg-gray-900 text-white rounded-md hover:bg-gray-800 transition-colors font-medium">
                                                Add
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SocialIntegrationsDashboard;